document.body.addEventListener('click', function (event) {
  var element = event.target;
  openSelectTag(element);
  openFileDialog(element);
  if (element.hasClass('select-file')) openSelectFile(element);
});
document.addEventListener('change', function (event) {
  var element = event.target;
  previewImage(element);
  if (element.hasAttribute('data-select-for')) previewFile(element);
});

function openSelectFile(el) {
  var parentTag = el.parentNode;
  var inputFileTag = parentTag.querySelector('input[type="file"]');
  if (!inputFileTag) return;
  inputFileTag.click();
}
function previewFile(el) {
  var idTaget = el.getAttribute('data-select-for');
  var elementTaget = document.querySelector('#' + idTaget);
  if (!elementTaget) return;

  elementTaget.value = el.value;

}
function openSelectTag(el) {
  var liTag = el.closest('li');
  var sizeTag = el.closest('.size-options');
  if (liTag && sizeTag) {
    if (!sizeTag.classList.contains('active')) {
      sizeTag.classList.add('active');
    } else {
      sizeTag.classList.remove('active');
      //select3Items.forEach(item => item.remove());
      sizeTag.querySelectorAll('.active').forEach((item) => {
        item.classList.remove('active');
        var dataFor = item.getAttribute('data-for');
        if (dataFor) {
          document.querySelectorAll('#' + dataFor).forEach(item => item.classList.add('d-none'));
        }
      });
      liTag.classList.add('active');
      var dataFor2 = liTag.getAttribute('data-for');
      if (dataFor2) {
        document.querySelectorAll('#' + dataFor2).forEach(item => item.classList.remove('d-none'));
      }
    }
  } else {
    document.querySelectorAll('.size-options').forEach(item => item.classList.remove('active'));
  }
}

function openFileDialog(el) {
  var preview = el.classList.contains('img-preview');
  if (!preview) {
    el = el.closest('.img-preview');
    preview = el;
  }
  if (preview) {
    var fileTag = el.querySelector('[type="file"]');
    if (fileTag) fileTag.click();
  }
}
function previewImage(el) {
  var previewTag = el.closest('.img-preview');
  if (el.tagName.toLowerCase() === 'input' && previewTag) {
    const file = el.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        var imageTag = previewTag.querySelector('img');
        imageTag.src = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
}